import styled from 'styled-components';

import { units } from '@calm-web/design-system';

export const Wrapper = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	gap: ${units(4)};
	padding: ${units(5)};
	text-align: center;
`;

export const Copy = styled.div`
	display: flex;
	flex-direction: column;
	gap: ${units(2)};
	max-width: 560px;
`;
